// extracted by mini-css-extract-plugin
export default {"dialog__content":"UpnEsoLookup_dialog__content__yD8Y4","person-search":"UpnEsoLookup_person-search__9qban"};